import { pipe } from 'fp-ts/function';
import * as O from 'monocle-ts/Optional';
import { Action } from 'redux-saga';
import { Future, FUTURE } from 'src/modules/common/types/Future';
import {
  SHARE_PROJECT_CHANGE_OWNER_OPEN,
  SHARE_PROJECT_CHANGE_OWNER_CLOSE,
  SHARE_PROJECT_CHANGE_OWNER_SUBMIT,
} from 'src/modules/sharing-projects/actions/ShareProjectActions';
import { ShareProjectModal, ShareProjectState } from 'src/modules/sharing-projects/types/ShareProjectState';

export function shareProjectChangeOwnerReducer(state: ShareProjectState, action: Action): ShareProjectState {
  if (SHARE_PROJECT_CHANGE_OWNER_OPEN.is(action)) {
    return pipe(state, modifyOwner({
      user: action.data,
      status: null,
    }));
  }
  if (SHARE_PROJECT_CHANGE_OWNER_CLOSE.is(action)) {
    return pipe(state, modifyOwner(null));
  }

  if (SHARE_PROJECT_CHANGE_OWNER_SUBMIT.isPending(action)) {
    return pipe(state, modifyStatus(FUTURE.pending()));
  }

  if (SHARE_PROJECT_CHANGE_OWNER_SUBMIT.isSuccess(action)) {
    if (state.data !== null) {
      return {
        ...state,
        data: {
          ...state.data,
          transferringOwnership: null,
        },
      };
    }

    return state;
  }
  if (SHARE_PROJECT_CHANGE_OWNER_SUBMIT.isFailure(action)) {
    return pipe(state, modifyStatus(FUTURE.failure(action.data)));
  }

  return state;
}

const dataLens = pipe(
  O.id<ShareProjectState>(),
  O.prop('data'),
  O.fromNullable,
);

function modifyOwner(
  value: ShareProjectModal | null,
): (state: ShareProjectState) => ShareProjectState {
  return pipe(
    dataLens,
    O.prop('transferringOwnership'),
    O.modify(() => value),
  );
}

function modifyStatus(
  value: Future<void>,
): (state: ShareProjectState) => ShareProjectState {
  return pipe(
    dataLens,
    O.prop('transferringOwnership'),
    O.fromNullable,
    O.prop('status'),
    O.modify(() => value),
  );
}
